import "./index.scss"

import React, { useEffect, useState } from "react"

import { popupApi } from "@shared/apis"
import { useAccount, useSchedule } from "@shared/contexts"
import { getIsPopupClosed, setIsPopupClosed } from "@shared/modules"
import { PlayerType } from "@shared/services/player"

interface Props {
  targetPlayer: PlayerType
}

function Notice({ targetPlayer }: Props) {
  const { schedule } = useSchedule()
  const { account } = useAccount()
  const [popup, setPopup] = useState<NoticeType>()
  const streamerId = schedule?.user.id
  const paymentInfo = schedule?.paymentInformation
  const role = account.viewer?.role

  useEffect(() => {
    if (!streamerId || !paymentInfo || !targetPlayer || !role) return

    popupApi
      .random({
        exposedTarget: paymentInfo,
        targetPlayer,
        userId: streamerId,
        viewerRole: role,
      })
      .then(({ data: popup }) => {
        popup.isClosed = !!getIsPopupClosed(popup.id)
        setPopup(popup)
      })
      .catch(() => {})
  }, [streamerId, paymentInfo, targetPlayer, role])

  return (
    <>
      {popup && !popup.isClosed && (
        <div className={`box-popup`}>
          {popup.contentsType === "IMAGE" ? (
            <img
              src={popup.imageUrl}
              className="popup__image"
              alt=""
              onClick={() => {
                popupApi.addClickCount(popup.id)
                window.open(popup.link)
              }}
            />
          ) : (
            <div
              className="popup__text"
              dangerouslySetInnerHTML={{ __html: popup.contents }}
            ></div>
          )}
          <div className="popup__footer">
            <div
              className="popup__footer__box"
              onClick={() => {
                let newPopup = { ...popup }
                newPopup.isClosed = true

                setIsPopupClosed(popup.id)
                setPopup(newPopup)
              }}
            ></div>
            <p className="popup__footer__text">일주일간 보지 않기</p>
            <p
              className="popup__footer__close"
              onClick={() => {
                let newPopup = { ...popup }
                newPopup.isClosed = true

                setPopup(newPopup)
              }}
            >
              닫 기
            </p>
          </div>
        </div>
      )}
    </>
  )
}

export default Notice

interface NoticeType {
  id: number
  userId: number
  nickname: string
  popupName: string
  imageUrl: string
  link: string
  exposedTarget: string
  exposedStartDate: string
  exposedEndDate: string
  weight: number
  clickCount: number
  exposedDays: string
  isEnabled: boolean
  createdAt: string
  updatedAt: string
  isClosed: boolean
  contents: string
  contentsType: "TEXT" | "IMAGE"
}
